var n = function (r) {
  return r.info = "info", r.warning = "warning", r.error = "error", r;
}(n || {});
export { n as TopHatType };